import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterPorId(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/gerentes/entregas/${entregaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorGerente(filtro) {
        return axiosJwt
            .get(
                `${api}/credenciados/gerentes/entregas?status=${filtro.status}&situacao=${filtro.situacao}&prazo=${filtro.prazo}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterEntregaAnexo(entregaAnexoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/gerentes/entregas/anexos/${entregaAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarReprovarEntrega(aprovaReprovaEntregaDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/gerentes/entregas/aprovar`,
                aprovaReprovaEntregaDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/gerentes/entregas/${entregaId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/gerentes/entregas/${entregaId}/historico`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}
